/** Poll often enough to show live Step 0 question / Step 4 AR counters. */
export const COVERAGE_POLL_MS = 2000;

function collectionComputing(data) {
    const cc = data?.collectionCoverage;
    if (!cc) {
        return false;
    }
    return Boolean(cc.computing);
}

function analyticComputing(data) {
    if (!data) {
        return false;
    }
    return Boolean(data.analyticCoverage?.computing ?? data.computing);
}

/** Pending score: C1 uses overallPct; questionsTotalCount > 0 means analytic coverage applies. */
function analyticScorePending(data) {
    const nest = data.analyticCoverage;
    const pct = nest?.overallPct ?? nest?.headlinePct ?? data.overallPct ?? data.overallScore;
    const total = nest?.questionsTotalCount
        ?? data.questionsTotalCount
        ?? data.requirementCount
        ?? 0;
    return pct == null && total > 0;
}

/** True while aggregate coverage may still be running (detail snapshot). */
export function shouldPollIcrCoverage(data, {recomputing = false} = {}) {
    if (recomputing || !data) {
        return false;
    }
    if (analyticComputing(data) || collectionComputing(data)) {
        return true;
    }
    return analyticScorePending(data);
}

/** True while any list-card summary is still computing or awaiting a score. */
export function shouldPollCoverageSummaries(coverageMap) {
    return Object.values(coverageMap || {}).some(summary => {
        if (!summary) {
            return false;
        }
        if (analyticComputing(summary) || collectionComputing(summary)) {
            return true;
        }
        return analyticScorePending(summary);
    });
}
